import axios from 'axios';

type FetchOptions = { force?: boolean };

function dedupeInflight<T>(
  slot: { current: Promise<T> | null },
  force: boolean | undefined,
  factory: () => Promise<T>
): Promise<T> {
  if (!force && slot.current) return slot.current;
  const promise = factory().finally(() => {
    if (slot.current === promise) slot.current = null;
  });
  slot.current = promise;
  return promise;
}

function templatesEndpoint(path: string): string {
  return (axios.defaults.baseURL || '').endsWith('/api') ? path : `/api${path}`;
}

const localTemplatesInflight: { current: Promise<any[]> | null } = { current: null };
const metaTemplatesInflight: { current: Promise<MetaTemplatesListResponse> | null } = { current: null };
const inActiveUseInflight: { current: Promise<string[]> | null } = { current: null };

export type MetaTemplatesListResponse = {
  success?: boolean;
  templates?: any[];
  synced?: {
    removed_count?: number;
    removed_templates?: string[];
  };
};

export function getLocalTemplates(options?: FetchOptions): Promise<any[]> {
  return dedupeInflight(localTemplatesInflight, options?.force, async () => {
    const res = await axios.get(templatesEndpoint('/templates/'));
    return Array.isArray(res.data) ? res.data : [];
  });
}

export function getMetaTemplatesList(options?: FetchOptions): Promise<MetaTemplatesListResponse> {
  return dedupeInflight(metaTemplatesInflight, options?.force, async () => {
    const res = await axios.get('/whatsapp/templates/meta/list');
    return res.data || {};
  });
}

export function getTemplatesInActiveUse(options?: FetchOptions): Promise<string[]> {
  return dedupeInflight(inActiveUseInflight, options?.force, async () => {
    const res = await axios.get(templatesEndpoint('/templates/in-active-use'));
    return Array.isArray(res.data?.template_names) ? res.data.template_names : [];
  });
}
